import { useEffect, useRef } from 'react';

const WIDGETS_SRC = 'https://platform.twitter.com/widgets.js';

declare global {
  interface Window {
    twttr?: { widgets?: { load?: (el?: HTMLElement) => void } };
  }
}

export function TweetEmbed({ url, className = '' }: { url: string; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const render = () => window.twttr?.widgets?.load?.(ref.current ?? undefined);

    if (window.twttr?.widgets) {
      render();
      return;
    }

    let script = document.querySelector<HTMLScriptElement>(`script[src="${WIDGETS_SRC}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = WIDGETS_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
    script.addEventListener('load', render);
    return () => script?.removeEventListener('load', render);
  }, [url]);

  return (
    <div ref={ref} className={className}>
      <blockquote className="twitter-tweet" data-theme="dark" data-dnt="true">
        <a href={url}>{url}</a>
      </blockquote>
    </div>
  );
}
